import { constants as orderConstants } from 'utils/order';
import isDateToday from 'utils/dateAndTimes/methods/isDateToday';

function calculatePriceType({ orderType, country, shipment }) {
  const priceType = orderConstants.PRICE_TYPES[orderType];

  const internalPriceType =
    isDateToday(shipment?.pickup_date_from) &&
    orderType === orderConstants.DIRECT_ORDER
      ? orderConstants.INTERNAL_TYPE_PRICE_TODAY
      : priceType;

  if (!orderConstants.COUNTRIES_WITH_SPECIAL_PRICES[country]) return {};
  if (!priceType) return {};

  return {
    price_type: priceType,
    internal_price_type: internalPriceType,
    x_docking_enabled: false,
  };
}

export { calculatePriceType };
